<template>
  <div class="row lists-pagination">
    <div class="col-sm-3 my-auto">
      <span style="font-size: 12px;">
        {{ paginationInfo.pageStart }}
        -
        {{ paginationInfo.pageEnd }}
        
        {{ $t('Pagination.of.label') }}
        
        <b>
          {{ getTotalLabel(paginationInfo.countTotal) }}
        </b>
      </span>
    </div>
    <div class="col-md-9 my-auto p-0 text-center">
      <b-button-group class="float-md-right" style="margin-top: 7px;">
        <input-button
          pointable
          :dissabled="!paginationInfo.canStepBack"
          variant="plainText"
          smallerFont
          :inputPlaceholder="$t('Button.paginationPrevious')"
          @click="prevPage" />

        <input-button
          pointable
          :dissabled="!paginationInfo.canStepForth"
          variant="plainText"
          smallerFont
          :inputPlaceholder="$t('Button.paginationNext')"
          @click="nextPage" />

      </b-button-group>
      <div class="float-md-right">
        <slot name="filterSlot" />
      </div>
    </div>
  </div>
</template>

<script>
import InputButton from '@/components/standard/input/InputButton'

export default {
  methods: {
    /**
     * Gives total label
     * @param {Number} total
     * @returns {String|Number}
     */
    getTotalLabel (total) {
      if (total < 0) return '?'
      return total
    },

    /**
     * Requests prev page
     */
    prevPage () {
      this.$emit('prevpage')
    },

    /**
     * Requests next page
     */
    nextPage () {
      this.$emit('nextpage')
    }
  },

  props: {
    paginationInfo: {
      type: Object,
      required: false,
      default: () => {return {}}
    }
  },
  components: {
    'input-button': InputButton
  }
}
</script>

<style scoped>
.lists-pagination {
  background-color: #FFF;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/standard/pagination/PaginationNavigation.vue?20226492